// extracted by mini-css-extract-plugin
module.exports = {"KeyFacts":"KeyFacts_KeyFacts__1BQyQ","Title":"KeyFacts_Title__xZjmj","List":"KeyFacts_List__3l4mT"};